/* import __COLOCATED_TEMPLATE__ from './switch.hbs'; */
var _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { guidFor } from '@ember/object/internals';
let Switch = (_class = class Switch extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "guid", `${guidFor(this)}-tailwindui-switch`);
    _defineProperty(this, "labelGuid", `${this.guid}-label`);
    _defineProperty(this, "buttonGuid", `${this.guid}-button`);
  }
  onLabelClick() {
    let buttonElement = document.getElementById(this.buttonGuid);
    buttonElement.click();
    buttonElement.focus();
  }
  onButtonClick(event) {
    event.preventDefault();
    this._toggle();
  }
  onButtonKeyUp(event) {
    event.preventDefault();
    if (event.key === ' ') {
      event.preventDefault();
      this._toggle();
    }
  }
  _toggle() {
    this.args.onUpdate(!this.args.isOn);
  }
}, (_applyDecoratedDescriptor(_class.prototype, "onLabelClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onLabelClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onButtonClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onButtonClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onButtonKeyUp", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onButtonKeyUp"), _class.prototype)), _class);
export { Switch as default };